// src/components/ColumnSettings.tsx
import { useEffect, useState } from "react";
import type { ColumnConfig } from "../lib/boardConfig";

type Props = {
  open: boolean;
  onClose: () => void;
  value: ColumnConfig[];
  onChange: (val: ColumnConfig[]) => void;
  onReset: () => void;
};

export default function ColumnSettings({ open, onClose, value, onChange, onReset }: Props) {
  const [local, setLocal] = useState<ColumnConfig[]>(value);

  useEffect(() => { if (open) setLocal(value); }, [open, value]);

  if (!open) return null;

  const move = (idx: number, dir: -1 | 1) => {
    const next = idx + dir;
    if (next < 0 || next >= local.length) return;
    const arr = local.slice();
    const [item] = arr.splice(idx, 1);
    arr.splice(next, 0, item);
    setLocal(arr);
  };

  const update = (idx: number, patch: Partial<ColumnConfig>) => {
    const arr = local.slice();
    arr[idx] = { ...arr[idx], ...patch };
    setLocal(arr);
  };

  const save = () => {
    onChange(local);
    onClose();
  };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-label="Ajustes de columnas">
      <div className="modal">
        <header className="modal-header">
          <h3>Ajustes de columnas</h3>
          <button className="icon-btn" onClick={onClose} aria-label="Cerrar">✕</button>
        </header>

        <div className="modal-body">
          <p className="muted" style={{ marginTop: 0 }}>
            Cambia el <strong>orden</strong>, el <strong>título</strong> y la <strong>visibilidad</strong> de las columnas. (Se guarda por proyecto).
          </p>

          <ul className="list" style={{ marginTop: 12 }}>
            {local.map((c, idx) => (
              <li key={c.key} className="list-item">
                <div className="row space-between">
                  <div className="row gap-sm">
                    <button className="icon-btn" title="Subir" onClick={() => move(idx, -1)}>↑</button>
                    <button className="icon-btn" title="Bajar" onClick={() => move(idx, +1)}>↓</button>
                    <code style={{ opacity: .6 }}>{c.key}</code>
                  </div>
                  <label className="row gap-sm">
                    <input type="checkbox" checked={c.visible} onChange={(e) => update(idx, { visible: e.target.checked })} />
                    <span>Visible</span>
                  </label>
                </div>

                <label className="kb-edit-field" style={{ marginTop: 8 }}>
                  <span>Título</span>
                  <input className="input" value={c.name} onChange={(e) => update(idx, { name: e.target.value })} />
                </label>
              </li>
            ))}
          </ul>
        </div>

        <footer className="modal-footer">
          <button className="btn btn-danger" onClick={onReset}>Restablecer</button>
          <div style={{ flex: 1 }} />
          <button className="btn" onClick={onClose}>Cancelar</button>
          <button className="btn btn-primary" onClick={save}>Guardar</button>
        </footer>
      </div>
    </div>
  );
}
